const PAGE_DESIGNER_MODULES = {
    HERO_XL_FULL: '01A_heroXLFull',
    HERO_XL_VIDEO_CLOUDINARY: '01BC_heroXLVideoCloudinary',
    DOUBLE_SAME_CLOUDINARY: '06C_doubleSameCloudinary',
    WALL_MIXED: '07_wallMixed',
    WALL_MIXED_IMAGE: '07_wallMixedImage',
    WALL_MIXED_VIDEO: '07C_wallMixedVideoCloudinary',
    TITLE_TEXT_CTA: '12_titleTextCta',
    MOUSEOVER: '23_mouseover',
    TWO_THIRDS_ONE_THIRD_CLOUDINARY: '25C_twoThirdsOneThirdCloudinary',
    STICKY_BANNER: '29_stickyBanner',
    STICKY_BANNER_VIDEO: '29_stickyBannerVideo',
    SHOP_THE_IMAGE: '31_shopTheImage',
    ANIMATED_SLIDE: '27_animatedSlide',
    EDITORIAL_SLIDER: '40_editorialSlider',
    SPACER: 'spacer',
} as const

export {PAGE_DESIGNER_MODULES}
